import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';

export default class ColumnCampaignId extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'CampaignId',
      property: 'Campaign/Id',
      title: 'ColumnName_CampaignID',
      sortable: 'Campaign/Id',
      type: 'number',
      i18n,
    });
  }
}
